import { baseClient, authClient, getServiceURL } from '@/utils'
import Toggles from '@domain/toggles/Toggles'

const fetchProductsByRef = ({ catalogId, matchingTerm, lang }) => {
	let response;
	let url;

	url = `${getServiceURL('apiv2')}/articles/byReference`

	response = authClient.get(url, {
		params: {
			catalogId,
			reference: matchingTerm,
			lang
		}
	})
	return response
}

const fetchVariations = ({ models, catalog = 16 }) => {
	return baseClient.get(`${getServiceURL('apiv2')}/articles/variations?${models.map(model => `model=${model}`).join('&')}&catalog=${catalog}`)
}

const generateCreationCode = (prefixCode) => {
	return authClient.post(
		`${getServiceURL('projects')}/v1/projects/products/generate-creation-code`,
		{
			prefixCode
		}
	)
}

const fetchModels = ({ catalogId, subFamilyId, applicationLocationId }) => {
	return baseClient.get(`${getServiceURL('products')}/v1/articles/models`, {
		params: {
			catalog: catalogId,
			subFamilyId,
			applicationLocationId
		}
	})
}

// DEPRECATED: Don't use. Categories are not created for all products right now.
const fetchReferences = ({ catalogId, subFamilyId, applicationLocationId, lang }) => {
	return authClient.get(`${getServiceURL('products')}/v1/categories/collections`, {
		params: {
			subFamilyId,
			applicationLocationId,
			catalogId,
			lang
		}
	})
}

const getProductFromPreconfig = (preconfigId) => {
	return authClient.get(
		`${getServiceURL('products')}/v1/preconfigs/creation/${preconfigId}`
	)
}

const getDecisionTree = (decisionTreeCode) => {
	return authClient.get(
		`${getServiceURL('products')}/v1/decision-trees/${decisionTreeCode}`
	)
}

const getLayerData = ({ layer, catalogId, familyId, subFamilyId, lang }) => {
	return authClient.get(
		`${getServiceURL('products')}/v1/decision-trees/layers/${layer}`,
		{
			params: {
				familyId,
				subFamilyId,
				catalogId,
				lang,
				visibility: layer === 'LAYER_C' ? 'website' : undefined
			}
		}
	)
}

const getProductAvailability = ({ product, lang }) => {
	return authClient.post(`${getServiceURL('sr-erp')}/v1/availability?lang=${lang}`, {
		products: [product]
	})
}
const getProductImages = ({ products = [], lang, catalogId }) => {
	return authClient.post(`${getServiceURL('products')}/v1/articles/get-image-details?catalogId=${catalogId}&lang=${lang}`,
		products
	)
}

const getPreconfigList = ({ catalogId, familyId, subFamilyId, lang }) => {
	if (Toggles.isEnabled("preconfigListWithCache")) {
		return baseClient.get(`${getServiceURL('apiv2')}/products/preconfigs/list`, {
			params: {
				catalogId,
				familyId,
				subFamilyId,
				lang,
				visibility: 'website'
			}
		})
	} else {
		return baseClient.get(`${getServiceURL('products')}/v1/preconfigs/list`, {
			params: {
				catalogId,
				familyId,
				subFamilyId,
				lang,
				visibility: 'website'
			}
		})
	}

}

const fechConfig = (creationCode) => {
	return authClient.get(`${getServiceURL('products')}/v1/configs/${creationCode}`)
}

const fechConfigv2 = (configId) => {
	return authClient.get(`${getServiceURL('apiv2')}/product/config/${configId}`)
}

export default {
	fetchProductsByRef,
	fetchVariations,
	fetchModels,
	fetchReferences,
	generateCreationCode,
	getProductFromPreconfig,
	getProductAvailability,
	getDecisionTree,
	getLayerData,
	getPreconfigList,
	getProductImages,
	fechConfig,
	fechConfigv2
}
